import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')

const UserResultCsv = {
  // ユーザー単位結果詳細CSV出力用のmethod
  methods: {
    $_getTargetDateList (campaign) {
      // 対象期間の取得
      const startDate = new Date(campaign.start)
      const endDate = new Date(campaign.end)
      let countDate = startDate
      const targetDateList = []
      while (countDate <= endDate && countDate <= new Date()) {
        targetDateList.push(dayjs(countDate).format('YYYY-MM-DD'))
        countDate = startDate.setDate(startDate.getDate() + 1)
      }
      return targetDateList
    },
    $_resultListFormatter (listDailyResult, targetDateList) {
      const dailyResultList = listDailyResult.daily_results
      const selectedCourseList = listDailyResult.select_course_list

      // 対象日の結果情報を取得し、整形
      return targetDateList.map((date) => {
        const dailyResultObj = dailyResultList.find(elm => date === elm.meta)
        // 対象日の結果情報があるとき
        if (dailyResultObj) {
          const valueObj = {}
          valueObj.date = dayjs(dailyResultObj.meta).format('YYYY/MM/DD(dd)')
          valueObj.day = dayjs(dailyResultObj.meta).day()
          valueObj.is_today = dailyResultObj.meta === dayjs().format('YYYY-MM-DD')
          valueObj.is_inputted = dailyResultObj.is_inputted
          valueObj.top_blood_pressure = dailyResultObj.top_blood_pressure
          valueObj.bottom_blood_pressure = dailyResultObj.bottom_blood_pressure
          valueObj.note = dailyResultObj.note
          if (dailyResultObj.select_course_result) {
            const courseList = selectedCourseList.map(selectCourse => {
              const existCourse = dailyResultObj.select_course_result.find(pastCourseResult => {
                return pastCourseResult.course_id === selectCourse.id
              })
              return {
                course_id: selectCourse.id,
                circle_and_cross: existCourse ? existCourse.circle_and_cross : null,
                integer: existCourse ? existCourse.integer : null,
                number: existCourse ? existCourse.number : null
              }
            })
            valueObj.select_course_result = courseList
          }
          return valueObj

        // 対象日の結果情報がないとき（空のオブジェクトを返す）
        } else {
          const selectCourseResult = selectedCourseList.map(elm => {
            return {
              course_id: elm.id,
              circle_and_cross: null,
              integer: null,
              number: null
            }
          })
          return {
            date: dayjs(date).format('YYYY/MM/DD(dd)'),
            day: dayjs(date).day(),
            is_today: date === dayjs().format('YYYY-MM-DD'),
            is_inputted: false,
            top_blood_pressure: null,
            bottom_blood_pressure: null,
            note: null,
            select_course_result: selectCourseResult
          }
        }
      }).reverse()
    },
    $_generateUserResultCsvList (selectedCourseList, dailyResults) {
      const csvData = []
      if (selectedCourseList) {
        for (const selectCourse of selectedCourseList) {
          const courseObj = {}
          courseObj['コース名'] = selectCourse.name
          courseObj['コースID'] = selectCourse.id
          csvData.push(courseObj)
        }

        const deepCopyList = dailyResults.map(list => ({ ...list }))
        for (const dailyResult of deepCopyList.reverse()) {
          // 1日の結果毎に格納
          const targetDate = dayjs(new Date(dailyResult.date)).format('YYYY/MM/DD(dd)')
          for (const result of dailyResult.select_course_result) {
            const csvRow = csvData.find(csvRow => csvRow['コースID'] === result.course_id)
            csvRow[targetDate] = this.$_getResultValue(result, selectedCourseList)
          }
        }
        for (const row of csvData) {
          delete row['コースID']
        }
        return csvData
      }
    },
    $_getResultValue (result, selectedCourseList) {
      const resultType = this.$_findResultType(result.course_id, selectedCourseList)
      return this.$_getCourseValue(resultType, result)
    },
    $_findResultType (courseId, selectedCourseList) {
      const courseInfo = selectedCourseList.find(elm => courseId === elm.id)
      return courseInfo.result_type
    },
    $_getCourseValue (resultType, selectCourse) {
      const CIRCLE_CROSS_VALUE = {
        circle: '○',
        cross: '×',
        none: '該当なし'
      }
      switch (resultType) {
        case 'CircleAndCross':
          return nullToEmpty(CIRCLE_CROSS_VALUE[selectCourse.circle_and_cross])
        case 'CircleCrossNone':
          return nullToEmpty(CIRCLE_CROSS_VALUE[selectCourse.circle_and_cross])
        case 'Integer':
          return nullToEmpty(selectCourse.integer)
        case 'Number':
          return nullToEmptyNumber(selectCourse.number)
      }
    }
  }
}

const nullToEmpty = (item) => {
  if (item === null || typeof item === 'undefined') {
    return ''
  }
  return item
}

const nullToEmptyNumber = (item) => {
  if (item === null || typeof item === 'undefined') {
    return ''
  }
  return '○'
}

export default UserResultCsv
